import { rehydrateDateAfterJsonization as Y } from "../util/date-utils.js";
export default class oi {
  constructor(t, i, s, l, h) {
    (this.endpoint = t),
      (this.Wu = i),
      (this.publicKey = s),
      (this.Yc = l),
      (this.xc = h),
      (this.endpoint = t || null),
      (this.Wu = i || null),
      (this.publicKey = s || null),
      (this.Yc = l || null),
      (this.xc = h || null);
  }
  gt() {
    return {
      e: this.endpoint,
      c: this.Wu,
      p: this.publicKey,
      u: this.Yc,
      v: this.xc,
    };
  }
  static _u(t) {
    return new oi(t.e, Y(t.c), t.p, t.u, t.v);
  }
}
